// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nav_active>a,.nav_ul li:hover a{color:#fff!important;font-weight:700}.el-tabs__item.is-top.is-active,.el-tabs__item:hover{color:#38a7f5}.el-tabs__active-bar{background-color:#38a7f5}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
